import anime from 'animejs';
import { requireNotNull } from '../../util/utils';

export class Animations {

  static animate (targets, payload, onComplete) {
    requireNotNull(targets);
    requireNotNull(payload);

    const animation = {
      targets,
      ...payload,
      complete: function () {
        if (!!onComplete) {
          onComplete();
        }
      }
    };

    return anime(animation);
  }

}
